import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import { hideLoader, showLoader } from "../Actions/PageLoaderAPI";

let user = JSON.parse(localStorage.getItem("currentUser"));

export const getShipName = (shipMail, id) => {
  let emailShip;
  if (shipMail) {
    emailShip = shipMail;
  } else {
    emailShip = user.email;
  }
  let url = `${API.shipInfo}?staffmail=${emailShip}&shipId=${id ?? 0}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getShipNameSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getShipNameFailure",
          error: "ERROR",
        });
      });
  };
};
export const getShipDetail = (pgno, shipMail, id) => {
  
  let emailShip;
  if (shipMail) {
    emailShip = shipMail;
  } else {
    emailShip = user.email;
  }
  let url = `${API.ShipDevice}?mail=${emailShip}&shipId=${id ?? 0}&PageNumber=${pgno}&PageSize=25`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getShipDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getShipDetailFailure",
          error: "ERROR",
        });
      });
  };
};

export const getShipTestRecords = (item, pgno, shipMail) => {
  let emailShip;
  if (shipMail) {
    emailShip = shipMail;
  } else {
    emailShip = user.email;
  }
  let url = `${API.TestRecordsList}?mail=${emailShip}&PageNumber=${pgno}&PageSize=25`;
  
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        
        dispatch({
          type: "getTestRecordsSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getTestRecordsFailure",
          error: "ERROR",
        });
      });
  };
};

export const postCrewMember = (data) => {
  let url = `${API.AddCrewMember}`;
  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        dispatch({
          type: "postCrewMemberSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "postCrewMemberFailure",
          error: "ERROR",
        });
      });
  };
};

export const getShippingCompanyList = (searchItem, companyMail) => {
  let emailCompany;
  if (companyMail) {
    emailCompany = companyMail;
  } else {
    emailCompany = user.email;
  }
  let url = `${API.ShipDetails}?mail=${emailCompany}&shipName=${searchItem.shipName}&CompanyName=${searchItem.companyName ?? ""}&ClientId=${searchItem.clientId??0}&PageNumber=${searchItem.PageNumber}&PageSize=${searchItem.PageSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
       dispatch({
          type: "getShippingCompanyListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getShippingCompanyListFailure",
          error: "ERROR",
        });
      });
  };
};

export const putMailAlert = (data) => {
  let url = `${API.ShippingSettings}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        if (response.data) {
          toast.success("Client User Mail Updated Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "putMailAlertSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "putMailAlertFailure",
          error: "ERROR",
        });
      });
  };
};
